export default __webpack_public_path__ + "static/tooltip-anatomy-light-7f56f45ac6b5c087ffa2dc142cf9c70e.png";